import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@/components/page'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_app/forbidden')({ component: Forbidden })

function Forbidden() {
  const { t } = useTranslation()
  return (
    <EmptyState title={t('forbidden.title')} body={t('forbidden.body')}>
      <Button asChild>
        <Link to="/">{t('notFound.home')}</Link>
      </Button>
    </EmptyState>
  )
}
